// External libraries
import React from 'react';
import { number, string } from 'prop-types';

import { HEADER_COLOR } from '@/styles';

const CartIcon = ({ color, height, width }) => (
  <svg
    height={height}
    viewBox={`0 0 ${height} ${width}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="m3 6c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h2.158c.68015008 0 1.27454519.45789792 1.4488838 1.11062833l2.07945275 7.51336477c.05846618.2207602.25861412.3760069.48366345.3760069h9.14c.2271328 0 .4261211-.1539426.4872391-.3888172l1.4578276-4.965915c.0801781-.30859902-.1407451-.6452678-.4840667-.6452678h-10.771c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h10.771c1.0387128 0 1.6877524.98908315 1.4477609 1.91181719l-1.4577427 4.96558751c-.1711707.6606589-.768276 1.1225953-1.4510182 1.1225953h-9.14c-.68029094 0-1.27611509-.4621569-1.4488838-1.1146283l-2.07917871-7.51233445c-.05879804-.22011575-.25730471-.37303725-.48393749-.37303725zm7.5 12c0-.5518576-.4481424-1-1-1-.55185763 0-1 .4481424-1 1s.44814237 1 1 1c.5518576 0 1-.4481424 1-1zm1 0c0 1.1041424-.8958576 2-2 2-1.10414237 0-2-.8958576-2-2s.89585763-2 2-2c1.1041424 0 2 .8958576 2 2zm8 0c0-.5518576-.4481424-1-1-1s-1 .4481424-1 1 .4481424 1 1 1 1-.4481424 1-1zm1 0c0 1.1041424-.8958576 2-2 2s-2-.8958576-2-2 .8958576-2 2-2 2 .8958576 2 2z"
      fill={color}
    />
  </svg>
);

CartIcon.defaultProps = {
  color: HEADER_COLOR,
  height: 24,
  width: 24,
};

CartIcon.propTypes = {
  color: string,
  height: number,
  width: number,
};

const ChevronIcon = ({ className }) => (
  <img
    alt="Chevron"
    className={className}
    // eslint-disable-next-line max-len
    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSI3cHgiIHZpZXdCb3g9IjAgMCAxNCA3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NSAoNzgwNzYpIC0gaHR0cHM6Ly9za2V0Y2hhcHAuY29tIC0tPgogICAgPHRpdGxlPkljb25zL2NoZXZyb24tdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iVjItVVMtRm9yY2VkLUFjYyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlVTLUZvcmNlZC1hY2MtQ29weS0xMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyOS4wMDAwMDAsIC0xMDMuMDAwMDAwKSIgZmlsbD0iIzJDMkUyRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IkhlYWRlci9SWUkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCA3Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJTdGFja2VkLUdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNDEuMDAwMDAwLCAxOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbnMvY2hldnJvbi11cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODIuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNi4zNTM1NTMzOSwxNC44NTM1NTM0IEM2LjE1ODI5MTI0LDE1LjA0ODgxNTUgNS44NDE3MDg3NiwxNS4wNDg4MTU1IDUuNjQ2NDQ2NjEsMTQuODUzNTUzNCBDNS40NTExODQ0NiwxNC42NTgyOTEyIDUuNDUxMTg0NDYsMTQuMzQxNzA4OCA1LjY0NjQ0NjYxLDE0LjE0NjQ0NjYgTDExLjY0NjQ0NjYsOC4xNDY0NDY2MSBDMTEuODQxNzA4OCw3Ljk1MTE4NDQ2IDEyLjE1ODI5MTIsNy45NTExODQ0NiAxMi4zNTM1NTM0LDguMTQ2NDQ2NjEgTDE4LjM1MzU1MzQsMTQuMTQ2NDQ2NiBDMTguNTQ4ODE1NSwxNC4zNDE3MDg4IDE4LjU0ODgxNTUsMTQuNjU4MjkxMiAxOC4zNTM1NTM0LDE0Ljg1MzU1MzQgQzE4LjE1ODI5MTIsMTUuMDQ4ODE1NSAxNy44NDE3MDg4LDE1LjA0ODgxNTUgMTcuNjQ2NDQ2NiwxNC44NTM1NTM0IEwxMiw5LjIwNzEwNjc4IEw2LjM1MzU1MzM5LDE0Ljg1MzU1MzQgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="
  />
);

ChevronIcon.propTypes = {
  className: string,
};

const InfoIcon = ({ fillColor, strokeColor, width, height }) => (
  <svg
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-31-1279h360V477H-31z" fill={fillColor} />
      <g transform="translate(-13 -13)">
        <rect
          fill={fillColor}
          height="64"
          rx="4"
          stroke={strokeColor}
          width="323"
          x=".5"
          y=".5"
        />
        <path
          // eslint-disable-next-line max-len
          d="M21 13c-4.411 0-8 3.59-8 8 0 4.412 3.589 8 8 8s8-3.588 8-8c0-4.41-3.589-8-8-8zm0 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);

InfoIcon.defaultProps = {
  fillColor: '#FFF',
  height: 18,
  strokeColor: '#FF9600',
  width: 18,
};

InfoIcon.propTypes = {
  fillColor: string,
  height: number,
  strokeColor: string,
  width: number,
};

export { CartIcon, ChevronIcon, InfoIcon };
